document.addEventListener('alpine:init', () => {
    Alpine.store('subscribeModal', {
        open: false,
    });
});

document.querySelector('.has-subscription-plans form.cart')?.addEventListener('submit', (event) => {

    // Only proceed if the form was submitted by the add to cart button
    if (!event.submitter?.classList.contains('single_add_to_cart_button')) {
        return;
    }

    // Check if the user has selected the subcription option
    const actionInput = document.querySelector('input[name="subscribe-to-action-input"]:checked');
    if (actionInput?.value === 'no') {
        event.preventDefault();
        Alpine.store('subscribeModal').open = true;
    }
});